import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M2.69995 27.7576C2.69995 27.7576 14.8099 36.2376 34.9599 34.9176C55.1099 33.5976 56.7599 23.6876 53.0199 20.1676C53.0199 20.1676 54.8899 8.93757 41.68 11.2476C41.68 11.2476 39.7 0.677569 30.7799 1.00757C21.8599 1.33757 20.87 13.2276 19.22 13.8876C17.57 14.5476 6.66995 11.9076 4.35995 21.1576C4.35995 21.1576 6.66995 19.5076 9.63995 20.4976C9.63995 20.4976 7.65995 25.7776 2.69995 27.7576Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M25.71 2.87769C25.71 2.87769 34.74 3.20769 32.87 19.9377"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M36.28 2.76758C36.28 2.76758 40.24 8.26758 34.63 19.9376"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M52.5699 16.7475C52.5699 16.7475 45.9599 13.5575 40.6799 20.8175"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6 19.2875C6 19.2875 9.63 16.5375 14.81 18.2975C19.98 20.0575 25.16 15.6575 27.47 20.4975"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M3.57996 27.8675C3.57996 27.8675 4.89996 28.8575 9.29996 26.6575C13.7 24.4575 17.12 19.0575 23.28 22.1475"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M23.51 5.96753C23.51 5.96753 31.99 7.28753 30.78 19.8375"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M58.17 31.1677C52.76 24.4077 40.55 20.4077 33.45 20.4077C26.35 20.4077 14.03 24.4077 8.61996 31.1677C-1.07004 43.2777 5.53996 69.9177 5.53996 69.9177C5.53996 69.9177 6.19996 48.3377 13.47 41.9577C19.66 36.5177 25.34 38.6077 33.4 38.6077C41.46 38.6077 47.14 36.5277 53.33 41.9577C60.6 48.3477 61.26 69.9177 61.26 69.9177C61.26 69.9177 67.85 43.2777 58.17 31.1677Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M26.83 20.9878C26.83 20.9878 24.35 26.5978 27.82 38.6578"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M19.2299 23.4578C19.2299 23.4578 15.2699 29.7378 18.2399 39.1478"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M15.7599 25.2778C15.7599 25.2778 10.4799 30.7278 12.6199 42.2878"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M8.27995 31.1677C8.27995 31.1677 2.71995 42.4477 7.66995 54.1777"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M39.96 20.9878C39.96 20.9878 42.44 26.5978 38.97 38.6578"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M47.5599 23.4578C47.5599 23.4578 51.5199 29.7378 48.5499 39.1478"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M51.03 25.2778C51.03 25.2778 56.31 30.7278 54.17 42.2878"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M58.51 31.1677C58.51 31.1677 64.07 42.4477 59.12 54.1777"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
    </g>
  )
}
